/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_LeaveInputs */

const en_us2_coaching_leave = /** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave group`)
};

const pt_br2_coaching_leave = /** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da turma`)
};

const pt_pt2_coaching_leave = /** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da turma`)
};

/** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */
const es_419_coaching_leave = en_us2_coaching_leave;

/** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */
const fr_fr2_coaching_leave = en_us2_coaching_leave;

/** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */
const de_de2_coaching_leave = en_us2_coaching_leave;

/** @type {(inputs: Coaching_LeaveInputs) => LocalizedString} */
const it_it2_coaching_leave = en_us2_coaching_leave;

/**
* | output |
* | --- |
* | "Leave group" |
*
* @param {Coaching_LeaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_leave = /** @type {((inputs?: Coaching_LeaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_LeaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_leave(inputs)
	if (locale === "es-419") return es_419_coaching_leave(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_leave(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_leave(inputs)
	if (locale === "de-DE") return de_de2_coaching_leave(inputs)
	if (locale === "it-IT") return it_it2_coaching_leave(inputs)
	return en_us2_coaching_leave(inputs)
});
export { coaching_leave as "coaching.leave" }